import { useContext, useEffect, useState, useLayoutEffect } from "react";
import {
  Alpha1Set,
  Area1Set,
  Color1Set,
  PromodeSet,
  Ratio1Set,
  Ratio2Set,
  Shikii1Set,
} from "../App";

export const HanreiHigh = ({ metadata }) => {
  const { area1set } = useContext(Area1Set);
  const { alpha1set } = useContext(Alpha1Set);
  const { color1set, setColor1Set } = useContext(Color1Set);
  const { shikii1set, setShikii1Set } = useContext(Shikii1Set);

  const { ratio1set, setRatio1Set } = useContext(Ratio1Set);
  const { ratio2set, setRatio2Set } = useContext(Ratio2Set);
  const { promodeset, setPromodeSet } = useContext(PromodeSet);

  // console.log(color1set[0]);
  const [col1, setCol1Set] = useState(
    color1set[0] || metadata.hanrei1_color || ""
  );
  const [col2, setCol2Set] = useState(
    color1set[1] || metadata.hanrei2_color || ""
  );
  const [col3, setCol3Set] = useState(
    color1set[2] || metadata.hanrei3_color || ""
  );
  const [col4, setCol4Set] = useState(
    color1set[3] || metadata.hanrei4_color || ""
  );
  const [col5, setCol5Set] = useState(
    color1set[4] || metadata.hanrei5_color || ""
  );

  useEffect(() => {
    const next = [col1, col2, col3, col4, col5].map(v => normHex(v, "#ffffff"));
    const cur = (Array.isArray(color1set) ? color1set : []).map(v => normHex(v, "#ffffff"));

    // 同じなら set しない（無限ループ/無駄レンダ防止）
    if (next.join("|") === cur.join("|")) return;

    // col1/2が空なら反映しない、等の既存仕様を維持するならここで条件
    if (next[0] && next[1]) setColor1Set(next);
  }, [col1, col2, col3, col4, col5]); // eslint-disable-line

  const normHex = (v, fallback = "#000000") => {
    const s = (v ?? "").toString().trim();
    if (!s) return fallback;
    return s.startsWith("#") ? s : `#${s}`;
  };

  // ★ 追加：Context(color1set) が更新されたら、ローカル state(col*) も同期
  useEffect(() => {
    // color1set が未定義/空の瞬間もあるので安全に
    const c = Array.isArray(color1set) ? color1set : [];

    // “未指定”は metadata 側にフォールバック
    setCol1Set(normHex(c[0] ?? metadata?.hanrei1_color ?? "", "#ffffff"));
    setCol2Set(normHex(c[1] ?? metadata?.hanrei2_color ?? "", "#ffffff"));
    setCol3Set(normHex(c[2] ?? metadata?.hanrei3_color ?? "", "#ffffff"));
    setCol4Set(normHex(c[3] ?? metadata?.hanrei4_color ?? "", "#ffffff"));
    setCol5Set(normHex(c[4] ?? metadata?.hanrei5_color ?? "", "#ffffff"));
  }, [color1set, metadata]);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setCol1Set(metadata.hanrei1_color);
  //     setCol2Set(metadata.hanrei2_color);
  //     setCol3Set(metadata.hanrei3_color || "");
  //     setCol4Set(metadata.hanrei4_color || "");
  //     setCol5Set(metadata.hanrei5_color || "");
  //   }, 500);

  //   // クリーンアップ関数を返してタイマーをクリア
  //   return () => clearTimeout(timer);
  // }, []); // 空の依存配列で初回レンダリング時のみ実行

  const setcol1 = (value) => {
    setCol1Set(value);
  };
  const setcol2 = (value) => {
    setCol2Set(value);
  };
  const setcol3 = (value) => {
    setCol3Set(value);
  };
  const setcol4 = (value) => {
    setCol4Set(value);
  };
  const setcol5 = (value) => {
    setCol5Set(value);
  };
  function pickerClicker1(e) {
    document.getElementById("bar1Picker").click();
    // console.log("クリック");
  }
  function pickerClicker2(e) {
    document.getElementById("bar2Picker").click();
  }
  function pickerClicker3(e) {
    document.getElementById("bar3Picker").click();
  }
  function pickerClicker4(e) {
    document.getElementById("bar4Picker").click();
  }
  function pickerClicker5(e) {
    document.getElementById("bar5Picker").click();
  }

  const [shiki1, setShiki1Set] = useState(shikii1set[0] || metadata.shikii1);
  const [shiki2, setShiki2Set] = useState(shikii1set[1] || metadata.shikii2);
  const [shiki3, setShiki3Set] = useState(
    shikii1set[2] || metadata.shikii3 || 0
  );
  const [shiki4, setShiki4Set] = useState(
    shikii1set[3] || metadata.shikii4 || 0
  );
  const [shiki5, setShiki5Set] = useState(
    shikii1set[4] || metadata.shikii5 || 0
  );

  useEffect(() => {
    if (shiki1 && shiki2) {
      setShikii1Set([shiki1, shiki2, shiki3 || 0, shiki4 || 0, shiki5 || 0]);
    }
  }, [shiki1, shiki2, shiki3, shiki4, shiki5]);

  const SVG_SCALE = 0.5;
  const SVG_INV = 1 / SVG_SCALE;

  const INPUT_SCALE = 0.3;          // 見た目を半分に
  const INPUT_INV = 1 / INPUT_SCALE;

  const scaledInputStyle = {
    fontSize: "16px",               // ★最重要：実サイズは16px
    lineHeight: "16px",
    transform: `scale(${INPUT_SCALE})`,
    transformOrigin: "0 0",         // 左上基準
    width: `${100 * INPUT_INV}%`,   // 縮小分を相殺して見た目の幅を維持
    height: `${100 * INPUT_INV}%`,  // 縮小分を相殺して見た目の高さを維持
    padding: 0,
    margin: 0,
    border: "none",
    background: "transparent",
    outline: "none",
    appearance: "textfield",        // numberのスピナーが邪魔なら
  };

  return (
    <>
      <div>
        <input
          type="color"
          value={col5}
          onChange={(e) => setcol5(e.target.value)}
          id="bar5Picker"
          className="invisible"
        />
        <input
          type="color"
          value={col4}
          onChange={(e) => setcol4(e.target.value)}
          id="bar4Picker"
          className="invisible"
        />
        <input
          type="color"
          value={col3}
          onChange={(e) => setcol3(e.target.value)}
          id="bar3Picker"
          className="invisible"
        />
        <input
          type="color"
          value={col2}
          onChange={(e) => setcol2(e.target.value)}
          id="bar2Picker"
          className="invisible"
        />
        <input
          type="color"
          value={col1}
          onChange={(e) => setcol1(e.target.value)}
          id="bar1Picker"
          className="invisible"
        />
      </div>

      <div className="cursor-pointer pointer-events-auto">
        {/* <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          viewBox="0 15 165 50"
          fontFamily='"Helvetica Neue",
              Arial,
              "Hiragino Kaku Gothic ProN",
              "Hiragino Sans",
              Meiryo,
              sans-serif;'
        > */}

<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 15 165 50"
  preserveAspectRatio="xMinYMin meet"
  style={{
    width: "100%",
    aspectRatio: "165 / 50",
    height: "auto",
    display: "block",
  }}
>
          <g id="参考" display="none"></g>
          <g id="背景の白色">
            {/* <rect x="0" y="0" opacity="0.75" fill="#FFFFFF" width="165" height="85"/> */}
          </g>

          <g
            id="bar1"
            type="color"
            // onChange={e => document.getElementById("bar1Picker").click()}
            onClick={pickerClicker1}
            pointerEvents="fill"
            className="svg-bars"
          >
            <polygon
              fill={col1}
              className={`hover:fill-red-500`}
              // className={`fill-[${"#e51400"}] hover:fill-blue-500`}
              points="104.231,14.064 91.565,15.231 81.899,58.564 84.065,60.064 89.565,60.23 114.731,18.897"
            />
            <polyline
              fill="none"
              stroke="#FFFFFF"
              strokeWidth="0.75"
              strokeLinecap="round"
              strokeMiterlimit="10"
              points="114.565,19.231 100.899,19.397 91.732,15.564 "
            />
            <line
              fill="none"
              stroke="#FFFFFF"
              strokeWidth="0.75"
              strokeLinecap="round"
              strokeMiterlimit="10"
              x1="84.399"
              y1="60.23"
              x2="100.899"
              y2="19.397"
            />
          </g>
          <g
            id="bar2"
            type="color"
            onClick={pickerClicker2}
            pointerEvents="fill"
            className="svg-bars"
          >
            {/* <g id="オレンジ棒"> */}
            <polygon
              fill={col2}
              className={`hover:fill-orange-500`}
              // fill={metadata.hanrei2_color}
              points="89.065,31.731 84.233,27.731 73.733,28.064 73.565,60.064 76.899,61.896 82.065,60.896 	"
            />
            <path fill="none" d="M90.399,81.064" />
            <polyline
              fill="none"
              stroke="#FFFFFF"
              strokeWidth="0.75"
              strokeLinecap="round"
              strokeMiterlimit="10"
              points="88.774,31.897 78.565,32.73 73.815,28.314 "
            />
            <line
              fill="none"
              stroke="#FFFFFF"
              strokeWidth="0.75"
              strokeLinecap="round"
              strokeMiterlimit="10"
              x1="76.733"
              y1="61.73"
              x2="78.565"
              y2="32.73"
            />
          </g>
          {/* <g id="黄色い棒"> */}
          {/* {col3 && ( */}
          <g
            id="bar3"
            type="color"
            onClick={pickerClicker3}
            pointerEvents="fill"
            className="svg-bars"
          >
            <polygon
              fill={col3}
              className={`hover:fill-yellow-500`}
              // fill={metadata.hanrei3_color}
              points="74.399,46.397 70.399,41.064 61.399,42.73 63.899,59.23 67.233,62.064 72.899,60.396 "
            />
            <polyline
              fill="none"
              stroke="#FFFFFF"
              strokeWidth="0.75"
              strokeLinecap="round"
              strokeMiterlimit="10"
              points="61.733,42.897 66.565,47.897 74.065,46.522 "
            />
            <line
              fill="none"
              stroke="#FFFFFF"
              strokeWidth="0.75"
              strokeLinecap="round"
              strokeMiterlimit="10"
              x1="67.233"
              y1="62.064"
              x2="66.565"
              y2="47.897"
            />
          </g>
          {/* )} */}
          {/* <g id="灰色の棒"> */}
          {/* {col4 && ( */}
          <g
            id="bar4"
            type="color"
            onClick={pickerClicker4}
            pointerEvents="fill"
            className="svg-bars"
          >
            <polygon
              fill={col4}
              className={`hover:fill-gray-500`}
              // fill={metadata.hanrei4_color}
              points="63.903,51.641 59.919,48.961 53.521,51.97 58.485,62.356 61.505,63.524 65.415,61.22 "
            />
            <polyline
              fill="none"
              stroke="#FFFFFF"
              strokeWidth="0.75"
              strokeLinecap="round"
              strokeMiterlimit="10"
              points="53.901,52.085 58.409,54.354 63.702,51.875 "
            />
            <line
              fill="none"
              stroke="#FFFFFF"
              strokeWidth="0.75"
              strokeLinecap="round"
              strokeMiterlimit="10"
              x1="61.546"
              y1="63.512"
              x2="58.409"
              y2="54.354"
            />
          </g>
          {/* )} */}
          {/* <g id="灰色の棒"> */}
          {/* {col5 && ( */}
          <g
            id="bar5"
            type="color"
            onClick={pickerClicker5}
            pointerEvents="fill"
            className="svg-bars"
          >
            <polygon
              fill={col5}
              // className={`hover:fill-gray-500`}
              // fill={metadata.hanrei4_color}
              points="55,55 50,54 45,57 50.485,64.356 54,65 58,62 "
            />
            <polyline
              fill="none"
              stroke="#FFFFFF"
              strokeWidth="0.75"
              strokeLinecap="round"
              strokeMiterlimit="10"
              points="45,57 50,58 55,55 "
            />
            <line
              fill="none"
              stroke="#FFFFFF"
              strokeWidth="0.75"
              strokeLinecap="round"
              strokeMiterlimit="10"
              x1="54"
              y1="65"
              x2="50"
              y2="58"
            />
          </g>
          {/* )} */}
          <g id="右の引き出し線と高さ凡例">
            <line
              fill="none"
              stroke="#000000"
              strokeWidth="0.5"
              strokeLinecap="round"
              strokeMiterlimit="10"
              x1="116.565"
              y1="19.189"
              x2="121.691"
              y2="19.189"
            />
            <line
              fill="none"
              stroke="#000000"
              strokeWidth="0.5"
              strokeLinecap="round"
              strokeMiterlimit="10"
              x1="119.316"
              y1="19.189"
              x2="119.316"
              y2="60.439"
            />
            <polygon points="121.566,23.564 116.94,23.439 119.316,18.939 " />
            <polygon points="117.065,55.939 121.691,56.064 119.316,60.564 " />
            <text transform="matrix(1 0 0 1 122.0239 30)" fontSize="5">
              高さ：
            </text>
            <text transform="matrix(1 0 0 1 123 40)" fontSize="5">
              {metadata.hanrei_height_name}
            </text>
            <text transform="matrix(1 0 0 1 123 48)" fontSize="5">
              {metadata.height_ratio}
            </text>
            <text transform="matrix(1 0 0 1 123 56)" fontSize="5">
              {metadata.hanrei_height_name_2}
            </text>
            <text transform="matrix(1 0 0 1 123 64)" fontSize="5">
              {metadata.hanrei_height_name_3}
            </text>
          </g>
          <g id="左上の引き出し線と色の凡例">
            <text transform="matrix(1 0 0 1 5 20.2715)" fontSize="5">
              色：{metadata.hanrei_color_name}{metadata.hanrei_color_name2}
            </text>
            <line
              fill="none"
              stroke="#000000"
              strokeWidth="0.5"
              strokeMiterlimit="10"
              x1="4.232"
              y1="22.731"
              x2="90.066"
              y2="22.731"
            />
            <circle cx="90" cy="22.897" r="1.083" />
          </g>

          <g id="左赤四角">
            <rect
              x="5"
              y="27.064"
              onClick={pickerClicker1}
              fill={col1}
              width="5.5"
              height="5.333"
            />
            {metadata.category_data ? (
              <text transform="matrix(1 0 0 1 13 31.2305)">
                <tspan
                  x="0"
                  y="0"
                  // onClick={shikiClicker1}
                  fontSize="5"
                >
                  {metadata.category_data
                    ? metadata.hanrei1_name
                    : shiki1 + "〜〜"}
                </tspan>
              </text>
            ) : (
              <>
                <foreignObject
                  x="13"
                  y="26.064"
                  width="20"
                  height="7"
                  fontSize="10"
                  className="text-black"
                >
                  <div
                    xmlns="http://www.w3.org/1999/xhtml"
                    className="text-[5px] text-center"
                  >
                    <input
                      type="number"
                      value={shiki1}
                      onChange={(e) => setShiki1Set(e.target.value)}
                      style={scaledInputStyle}
                    />
                  </div>
                </foreignObject>
                <text transform="matrix(1 0 0 1 34 31.2305)">
                  <tspan
                    x="0"
                    y="0"
                    // onClick={shikiClicker1}
                    fontSize="10"
                  >
                    〜
                  </tspan>
                </text>
              </>
            )}
          </g>

          <g id="左オレンジ四角">
            <rect
              x="5"
              y="34.564"
              onClick={pickerClicker2}
              fill={col2}
              // fill={metadata.hanrei2_color}
              width="5.5"
              height="5.333"
            />
            {metadata.category_data ? (
              <text transform="matrix(1 0 0 1 13 38.7305)">
                <tspan
                  x="0"
                  y="0"
                  // onClick={shikiClicker1}
                  fontSize="10"
                >
                  {metadata.category_data
                    ? metadata.hanrei2_name
                    : shiki2 + "〜〜" + shiki1}
                </tspan>
              </text>
            ) : (
              <>
                <foreignObject
                  x="13"
                  y="33.564"
                  width="20"
                  height="7"
                  fontSize="10"
                  className="text-black"
                >
                  <div
                    xmlns="http://www.w3.org/1999/xhtml"
                    className="text-[5px] text-center"
                  >
                    <input
                      type="number"
                      value={shiki2}
                      onChange={(e) => setShiki2Set(e.target.value)}
                      style={scaledInputStyle}
                    />
                  </div>
                </foreignObject>
                <text transform="matrix(1 0 0 1 34 38.7305)">
                  <tspan
                    x="0"
                    y="0"
                    // onClick={shikiClicker1}
                    fontSize="10"
                  >
                    〜
                  </tspan>
                </text>
                {/* <foreignObject
                  x="40"
                  y="33.564"
                  width="20"
                  height="7"
                  fontSize="10"
                  className="text-black"
                >
                  <div
                    xmlns="http://www.w3.org/1999/xhtml"
                    className="text-[5px] text-center"
                  >
                    <input
                      type="number"
                      value={shiki1}
                      onChange={(e) => setShiki1Set(e.target.value)}
                    />
                  </div>
                </foreignObject> */}
              </>
            )}
            {/*
                <text transform="matrix(1 0 0 1 13 38.7305)">
                  <tspan
                    x="0"
                    y="0"

                    fontSize="10"
                  >
                    { metadata.category_data ? metadata.hanrei2_name : metadata.shikii2+"〜〜"+metadata.shikii1}
                  </tspan>
                </text> */}
          </g>

          <g id="左黄色四角">
            <rect
              x="5"
              y="42.064"
              onClick={pickerClicker3}
              fill={col3}
              // fill={metadata.hanrei3_color}
              width="5.5"
              height="5.333"
            />
            {metadata.category_data ? (
              <text transform="matrix(1 0 0 1 13 46.2305)">
                <tspan
                  x="0"
                  y="0"
                  // onClick={shikiClicker1}
                  fontSize="10"
                >
                  {metadata.category_data
                    ? metadata.hanrei3_name
                    : shiki3 + "〜〜" + shiki2}
                </tspan>
              </text>
            ) : (
              <>
                <foreignObject
                  x="13"
                  y="41.064"
                  width="20"
                  height="7"
                  fontSize="10"
                  className="text-black"
                >
                  <div
                    xmlns="http://www.w3.org/1999/xhtml"
                    className="text-[5px] text-center"
                  >
                    <input
                      type="number"
                      value={shiki3}
                      onChange={(e) => setShiki3Set(e.target.value)}
                      style={scaledInputStyle}
                    />
                  </div>
                </foreignObject>
                <text transform="matrix(1 0 0 1 34 45.7305)">
                  <tspan
                    x="0"
                    y="0"
                    // onClick={shikiClicker1}
                    fontSize="10"
                  >
                    〜
                  </tspan>
                </text>
                {/* <foreignObject
                  x="40"
                  y="41.064"
                  width="20"
                  height="7"
                  fontSize="10"
                  className="text-black"
                >
                  <div
                    xmlns="http://www.w3.org/1999/xhtml"
                    className="text-[5px] text-center"
                  >
                    <input
                      type="number"
                      value={shiki2}
                      onChange={(e) => setShiki2Set(e.target.value)}
                    />
                  </div>
                </foreignObject> */}
              </>
            )}
          </g>

          <g id="左灰色四角">
            <rect
              x="5"
              y="49.564"
              onClick={pickerClicker4}
              fill={col4}
              // fill={metadata.hanrei4_color}
              width="5.5"
              height="5.333"
            />
            {metadata.category_data ? (
              <text transform="matrix(1 0 0 1 34 46.2305)">
                <tspan
                  x="0"
                  y="0"
                  // onClick={shikiClicker1}
                  fontSize="10"
                >
                  {metadata.category_data
                    ? metadata.hanrei4_name
                    : shiki4 + "〜〜" + shiki3}
                </tspan>
              </text>
            ) : (
              <>
                <text transform="matrix(1 0 0 1 34 53.7305)">
                  <tspan
                    x="0"
                    y="0"
                    // onClick={shikiClicker1}
                    fontSize="10"
                  >
                    〜
                  </tspan>
                </text>
                <foreignObject
                  x="13"
                  y="48.564"
                  width="20"
                  height="7"
                  fontSize="10"
                  className="text-black"
                >
                  <div
                    xmlns="http://www.w3.org/1999/xhtml"
                    className="text-[5px] text-center"
                  >
                    <input
                      type="number"
                      value={shiki4}
                      onChange={(e) => setShiki4Set(e.target.value)}
                      style={scaledInputStyle}
                    />
                  </div>
                </foreignObject>
              </>
            )}
          </g>

          <g id="左５つ目四角">
            <rect
              x="5"
              y="57.064"
              onClick={pickerClicker5}
              fill={col5}
              // fill={metadata.hanrei4_color}
              width="5.5"
              height="5.333"
            />
            {metadata.category_data ? (
              <text transform="matrix(1 0 0 1 13 46.2305)">
                <tspan
                  x="0"
                  y="0"
                  // onClick={shikiClicker1}
                  fontSize="10"
                >
                  {metadata.category_data
                    ? metadata.hanrei5_name
                    : shiki5 + "〜〜" + shiki4}
                </tspan>
              </text>
            ) : (
              <>
                <text transform="matrix(1 0 0 1 34 61.2305)">
                  <tspan
                    x="0"
                    y="0"
                    // onClick={shikiClicker1}
                    fontSize="10"
                  >
                    〜
                  </tspan>
                </text>
                <foreignObject
                  x="13"
                  y="56.064"
                  width="20"
                  height="7"
                  fontSize="10"
                  className="text-black"
                >
                  <div
                    xmlns="http://www.w3.org/1999/xhtml"
                    className="text-[5px] text-center"
                  >
                    <input
                      type="number"
                      value={shiki5}
                      onChange={(e) => setShiki5Set(e.target.value)}
                      style={scaledInputStyle}
                    />
                  </div>
                </foreignObject>
              </>
            )}
          </g>
        </svg>
      </div>

      <></>
    </>
  );
};
